import React, { PropsWithChildren } from "react";
import { View, StatusBar as RNStatusBar, StyleSheet } from "react-native";
import { StatusBar } from "expo-status-bar";

import { sizes, colors } from "asset/constant";
import { useSN } from "hook";
import { css } from "style";

const bgColor = colors.white;

const HeaderLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const sn = useSN();

  return (
    <>
      <StatusBar style="dark" backgroundColor={bgColor} />
      {<View style={{ height: RNStatusBar.currentHeight }} />}

      <View
        style={{
          ...css.shadowForWeb(10),
          ...styles.dropShadow,
          borderTopLeftRadius: sn(0, 0, radius, radius),
          borderTopRightRadius: sn(0, 0, radius, radius),
          marginTop: sn(0, 0, 0, sizes.space),
          width: sn("100%", "100%", "100%", "98%"),
          backgroundColor: colors.white,
          overflow: "hidden",
        }}
      >
        <View style={styles.contentWrapper}>{children}</View>
      </View>
    </>
  );
};

const height = 65;
const radius = sizes.radius.md;

const styles = StyleSheet.create({
  dropShadow: {
    height,
    alignSelf: "center",
    borderBottomLeftRadius: radius,
    borderBottomRightRadius: radius,
    // overflow: "hidden",
  },

  contentWrapper: {
    width: "100%",
    height: "100%",
    alignSelf: "center",
    backgroundColor: bgColor,
  },
});

export default HeaderLayout;
